<template>

	<b-modal ref="profile_modal" size="xl" bodyClass="p-0" v-bind:no-close-on-backdrop=true
			 :hide-footer=true
			 :hide-header=true
			 v-model="is_show_modal"
			 :dialogClass=dialog_class_draw>

		<template v-slot:modal-header="{ close }">
			<!-- Emulate built in modal header close button action -->
			<b-button size="sm" variant="outline-danger" @click="close()">
				Close Modal
			</b-button>
		</template>

		<div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
			<div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
				<h2 v-if="this.user.id > 0">
					{{this.user.name}} <span class="fw-300">ID:{{this.user.id}}</span>
				</h2>
				<div class="panel-toolbar pr-3 pb-2 align-self-end">
					<button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
						<i class="fal fa-times"></i>
					</button>
				</div>
			</div>

			<div class="panel-container show">
				<div class="panel-content">
					<div class="d-flex flex-column align-items-center justify-content-center p-4">

						<picture v-if="parseInt(user.id) > 0">
							<source :srcset="user_avatar_template | get_image_from_template(150,150,'webp')"
									type="image/webp"/>
							<source :srcset="user_avatar_template | get_image_from_template(150,150,'png')"
									type="image/png"/>

							<img :src="user_avatar_template | get_image_from_template(150,150,'png')" alt=""
								 class="rounded-circle shadow-2 img-thumbnail imc_user_profile_img" />
						</picture>

						<h5 class="mb-0 fw-700 text-center mt-3">
							{{this.user.name}}
							<small class="text-muted mb-0" v-text=user_company></small>
							<small class="text-muted mb-0" v-text=this.user.dolznost></small>
						</h5>
					</div>

					<b-overlay  :show="is_loading" rounded="sm">
						<b-tabs content-class="mt-3">
							<b-tab v-for="(tab,index) in tabs" @click="set_active(index)" :title="get_tab_title(tab)" :key="index" :active="tab.is_active">
								<template slot="title">
									{{get_tab_title(tab)}}
									<b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
								</template>
								<component v-bind:is="tab.index"  :user="user" :user_id=parseInt(user_id)></component>
							</b-tab>
						</b-tabs>
					</b-overlay>

				</div>
			</div>
		</div>
	</b-modal>

</template>

<script>
import home from "./tabs/home";
import profile1c from "./tabs/profile1c";
import equipment from "./tabs/equipment";
import groups from "./tabs/groups";
import mobile from "./tabs/mobile";

export default {
	name: "user_profile",
	components : {
		home,
		profile1c,
		equipment,
		groups,
		mobile
	},

	props : {
		modal_position : {
			type : String,
			default : "left"
		},
	},
	data() {
		return  {
			is_show_modal : false,
			is_loading : false,
			user: {
				id : 0,
				company : "",
				department : ""
			},
			tabs:[]
		}
	},

	created() {
		EventBus.$on("click_user_photo",res => this.work_click(res));
	},

	methods : {

		async get_user(user_id) {
			return api.get('/user/' + parseInt(user_id))
		},

		close() {
			this.user = {
				id: 0
			};
			this.tabs = [];
			this.is_load = false;
			this.is_show_modal = false;
		},

		work_click(user_id) {
			this.is_loading = true;

			this.get_user(user_id).then(({data}) => {
				if (data.status === "operation_success") {
					this.user = data.data;
					this.init_tabs(data.message)
				}
			}).catch(err => {
				this.is_loading = false;
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
				this.is_load = false;
			});

			this.is_show_modal = true;
		},

		async init_tabs(tabs_in) {
			this.tabs = [];
			tabs_in.map(tab => {
				if(tab.hasOwnProperty("index")) {
					this.tabs.push({
						'index' : tab.index,
						'title' : tab.title,
						'is_load' : false,
						'is_active' : tab.index === 'home'
					});
				}
			});
			this.is_loading = false;
		},

		get_tab_title(tab) {
			if (tab.count > 0) {
				return tab.title;
			}
			return tab.title;
		},

		set_active(obj) {
			for (let tab in this.tabs) {
				this.tabs[tab].is_active = false;
			}
			this.tabs[obj].is_active = true;
			EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
		},
	},

	computed : {
		dialog_class_draw () {
			if(this.modal_position === "left") {
				return "modal-dialog-left modal-lg";
			}

			return "modal-dialog-right modal-lg";
		},

		user_company () {
			if(this.obj_to_null(this.user) != null) {
				return this.user.company + ", " + this.user.department
			}
		},
		user_avatar() {
			try {
				if (this.user.id > 0) {
					if (this.user.hasOwnProperty('avatar')) {
						return this.user.avatar;
					}
				}
			} catch (e) {

			}
			return null;
		},

		user_avatar_template() {
			if (this.user_avatar.hasOwnProperty('template')) {
				return this.user_avatar.template;
			}

			return "";
		},

		user_id() {
			return  this.user.id;
		},

	}
}
</script>

<style scoped>

</style>
